import TeamMemberSideNavigation from '@features/organisation/components/TeamMemberSideNavigation'
import { Outlet } from 'react-router-dom'
import styled from 'styled-components'

const TeamScreen = () => {
  return (
    <MainContainer data-testid="team-screen">
      <TeamMemberSideNavigation testId="team-screen-navigation" />
      <OutletContainer data-testid="team-screen-content">
        <Outlet />
      </OutletContainer>
    </MainContainer>
  )
}

const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin: 0px auto;
  height: calc(-65px + 100vh);
`

const OutletContainer = styled.div`
  word-wrap: break-word;
  width: 100%;
  overflow-y: auto;
  padding: 0 0 24px;
  max-width: 1080px;
  margin: 0 auto;

  /*
   * Reserve space for a fixed footer (e.g. the profile edit screen) so the
   * scroll container ends above it and its scrollbar doesn't overlap the
   * footer. Auto-scoped: screens without a footer keep the full height.
   */
  &:has(.lmc-fixed-footer) {
    margin-bottom: 72px;
  }
`

export default TeamScreen
